import { Api } from 'models/services/api';
import { ReadBusinessCategoriesQuery } from 'models/services/graphql';

import { BusinessCategoryCollectionData } from '../collection';

type DataToRead = {
  nextToken?: string;
};

const RequestQuery = `
  query BusinessCategories($nextToken: String) {
    ${ReadBusinessCategoriesQuery}
  }
`;

type ResponseData = {
  data: {
    readBusinessCategories: BusinessCategoryCollectionData;
  }
};

class ReadCollectionGql {

  readonly result?: BusinessCategoryCollectionData;
  private readonly api: Api<ResponseData>;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToRead = {}): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const result = api.response.data.readBusinessCategories;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, result, api });
  }

}

export { ReadCollectionGql };
